<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
      <c-card title="교육대상자 추가" class="cardClassDetailForm">
        <template slot="card-detail">
          <div class="col-3">
            <c-plant type="search" name="plantCd" v-model="searchParam.plantCd"/>
          </div>
          <div class="col-5">
            <c-dept
              :editable="editable"
              :isFirstValue="false"
              :plantCd="searchParam.plantCd"
              label="부서"
              name="deptCd"
              v-model="searchParam.deptCd">
            </c-dept>
          </div>
          <div class="col-4">
            <c-text
              label="사용자명"
              name="userName"
              v-model="searchParam.userName"
              @input="getTargetUserList">
            </c-text>
          </div>
          <div class="col-12" style="margin-top: -20px">
            <div class="row">
              <div class="col-11">
                <c-table
                  ref="gridUser"
                  title="사용자 목록"
                  tableId="gridUser"
                  :columns="gridUser.columns"
                  :gridHeight="gridUser.height"
                  :data="gridUser.data"
                  :columnSetting="false"
                  :isFullScreen="false"
                  :usePaging="false"
                  :expandAll="true"
                  :isExcelDown="false"
                  selection="multiple"
                  rowKey="userId"
                >
                  <!-- 버튼 영역 -->
                  <template slot="table-button">
                    <q-btn-group outline >
                      <c-btn
                        label="검색"
                        icon="search" @btnClicked="getTargetUserList"/>
                    </q-btn-group>
                  </template>
                </c-table>
              </div>
              <div class="col-1" style="line-height: 35px; text-align:center;padding-top:100px !important">
                <c-btn v-if="editable" label="" icon="arrow_forward_ios" color="blue-7" @btnClicked="selectAdd" />
              </div>
            </div>
          </div>
        </template>
      </c-card>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
      <c-table
        ref="table"
        title="교육대상자 목록"
        :columns="grid.columns"
        :gridHeight="grid.height"
        :data="grid.data"
        :filtering="false"
        :checkClickFlag="false"
        :columnSetting="false"
        :usePaging="false"
        :merge="grid.merge"
        :isExcelDown="false"
        :hideBottom="true"
        noDataLabel="교육대상자가 없습니다."
        :editable="editable && !disabled"
        rowKey="attendeesNo"
        selection="multiple"
      >
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn v-if="editable && !disabled && isEnv" label="대상자 메일 발송" icon="mail_outline" @btnClicked="sendMail"/>
            <c-btn v-if="editable && !disabled" label="교육계획별 대상자 추가" icon="add" @btnClicked="openPlan"/>
            <c-btn v-if="editable && !disabled" label="교육대상자 업로드" icon="assignment" @btnClicked="openExcelUploader"/>
            <!-- <c-btn v-if="editable && !disabled" label="추가" :showLoading="false"  icon="add" @btnClicked="addItem('DEPT')" /> -->
            <!-- <c-btn
              v-if="editable && !disabled && grid.data.length > 0"
              :url="insertUrl"
              :isSubmit="isSave1"
              :param="grid.data"
              mappingType="POST"
              label="저장"
              icon="save"
              @beforeAction="saveEducation1"
              @btnCallback="saveCallback1" 
            /> -->
            <c-btn v-if="editable && !disabled && grid.data.length > 0" label="삭제" :showLoading="false" icon="remove" @btnClicked="removeItem" />
          </q-btn-group>
        </template>
      </c-table>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-table
        ref="table4"
        title="협력업체 직원"
        :columns="grid2.columns"
        :gridHeight="grid2.height"
        :data="grid2.data"
        :checkClickFlag="false"
        :filtering="false"
        :columnSetting="false"
        :usePaging="false"
        :isExcelDown="false"
        :hideBottom="true"
        :defaultExpand="false"
        collapsed
        noDataLabel="교육대상자가 없습니다."
        :editable="editable && !disabled"
        rowKey="attendeesNo"
        selection="multiple"
      >
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn v-if="editable && !disabled" label="추가" :showLoading="false"  icon="add" @btnClicked="addItem4" />
            <c-btn v-if="editable && !disabled && grid2.data.length > 0" label="삭제" :showLoading="false" icon="remove" @btnClicked="removeItem4" />
            <c-btn
              v-if="editable && !disabled && grid2.data.length > 0"
              :url="insertUrl"
              :isSubmit="isSave2"
              :param="grid2.data"
              mappingType="POST"
              label="저장"
              icon="save"
              @beforeAction="saveEducation2"
              @btnCallback="saveCallback2" 
            />
          </q-btn-group>
        </template>
      </c-table>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'education-result-target-user',
  props: {
    tabParam: {
      type: Object,
      default: () => ({
        plantCd: '',
        eduEducationId: '',
        eduCourseId: '',
        documentStatusCd: '',
        eduAttendeeList: [],
        educationTime: '',
        educationEndDate: '',
        sumEducationTime: '',
      }),
    },
    param: {
      type: Object,
      default: () => ({
        eduEducationId: '',
        completeSt: '',
      }),
    },
  },
  data() {
    return {
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      grid: {
        columns: [
          {
            name: 'attendeesDeptName',
            field: 'attendeesDeptName',
            style: 'width:20%',
            label: '부서',
            align: 'center',
            sortable: false,
          },
          {
            name: 'attendeesPositionName',
            field: 'attendeesPositionName',
            style: 'width:20%',
            label: '직무',
            align: 'center',
            sortable: false,
          },
          {
            name: 'seniorityName',
            field: 'seniorityName',
            style: 'width:20%',
            label: '법규/선해임',
            align: 'center',
            sortable: false,
          },
          {
            name: 'attendeesName',
            field: 'attendeesName',
            label: '대상자명',
            style: 'width:20%',
            align: 'center',
            sortable: false
          },
          {
            name: 'enterDate',
            field: 'enterDate',
            label: '입사일',
            style: 'width:20%',
            align: 'center',
            sortable: false
          },
        ],
        data: [],
        height: '413px'
      },
      grid2: {
        columns: [
          {
            name: 'companyName',
            field: 'companyName',
            label: '소속회사',
            align: 'center',
            style: 'width:25%',
            type: 'text',
            sortable: false,
          },
          {
            name: 'attendeesPositionName',
            field: 'attendeesPositionName',
            style: 'width:25%',
            label: '직책',
            type: 'text',
            align: 'center',
            sortable: false,
          },
          {
            name: 'attendeesName',
            field: 'attendeesName',
            label: '대상자명',
            type: 'text',
            style: 'width:25%',
            align: 'center',
            sortable: false
          },
          {
            name: 'residentNo',
            field: 'residentNo',
            label: '생년월일',
            type: 'date',
            style: 'width:25%',
            align: 'center',
            sortable: false
          },
        ],
        data: [],
        height: '260px'
      },
      gridUser: {
        columns: [
          {
            name: 'deptName',
            field: 'deptName',
            label: '부서',
            align: 'center',
            sortable: false,
          },
          {
            name: "jobName",
            field: "jobName",
            label: "직무",
            align: "center",
            sortable: true,
          },
          {
            name: 'userName',
            field: 'userName',
            label: '사용자명',
            align: 'center',
            sortable: false,
          },
          {
            name: "enterDate",
            field: "enterDate",
            label: "입사일",
            align: "center",
            sortable: true,
          },
        ],
        height: '283px',
        data: [],
      },
      editable: true,
      getUrl: '',
      targetClassCd: '',
      updateMode: false,
      items: [],
      sendMailUrl: '',
      saveUrl: 'transactionConfig.sop.edu.plan.insert.url',
      saveType: 'POST',
      isSave1: false,
      isSave2: false,
      updateUrl: '',
      insertUrl: '',
      deleteUrl: '',
      targetUserUrl: '',
      searchParam: {
        plantCd: null,
        userName: '',
        deptCd: '',
      },
    };
  },
  computed: {
    disabled() {
      return Boolean(this.tabParam.documentStatusCd) && this.tabParam.documentStatusCd === 'ESC000010'
    },
    isEnv() {
      /**
       * 1. 교육(환경)에 대해서만 담당자에게 대상자 목록을 메일로 전송
       * 2. 환경센터 권한을 가지는 사람만 이용 : SAGI000008
       */
      return this.tabParam.educationKindCdLarge === 'EKFC000002'
        && this.$_.indexOf(this.$store.getters.user.sysAuthGrpIds, 'SAGI000008') > -1
    }
  },
  watch: {
    'param.completeSt'() {
      this.getAttendList();
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.targetUserUrl = selectConfig.sop.edu.user.list.url;
      this.getUrl = selectConfig.sop.edu.attendee.get.url;
      this.insertUrl = transactionConfig.sop.edu.plan.insert.targetUser.url;
      this.deleteUrl = transactionConfig.sop.edu.plan.delete.targetUser.url;
      this.sendMailUrl = transactionConfig.sop.edu.plan.mail.targetUser.url;
      // code setting
      this.searchParam.plantCd = this.tabParam.plantCd;
      // list setting
      this.getDetail();
    },
    getTargetUserList() {
      this.$http.url = this.targetUserUrl;
      this.$http.type = 'GET';
      this.$http.isLoading = false;
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.gridUser.data = _result.data;
        this.$refs['gridUser'].selected = [];
      },);
    },
    getDetail() {
      if (this.tabParam.eduEducationId) {
        this.grid.data = [];
        this.grid2.data = [];
        this.$_.forEach(this.tabParam.eduAttendeeList, _item => {
          if (_item.attendeesTypeCd === 'EATC00004') {
            this.grid2.data.push(_item) // 부서
          } else {
            this.grid.data.push(_item) // 선임
          }
        })
      }
    },
    getAttendList() {
      this.$http.url = this.$format(selectConfig.sop.edu.result.get.url, this.tabParam.eduEducationId);
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.tabParam.eduAttendeeList = _result.data.eduAttendeeList
        this.grid.data = [];
        this.grid2.data = [];
        this.$_.forEach(this.tabParam.eduAttendeeList, _item => {
          if (_item.attendeesTypeCd === 'EATC00004') {
            this.grid2.data.push(_item) // 부서
          } else {
            this.grid.data.push(_item) // 선임
          }
        })
      },);
    },
    addItem(data) {
      if (data === 'DEPT') this.targetClassCd = '1';
      else this.targetClassCd = '4';

      if (this.targetClassCd === '4') {
        this.grid2.data.splice(0, 0, {
          eduCourseId: this.tabParam.eduCourseId,
          attendeesNo: uuidv4(),
          eduEducationId: this.tabParam.eduEducationId,
          attendeesTypeCd: 'EATC00004',
          attendeesTypeName: '',
          attendeesPositionName: '',
          companyName: '',
          residentNo: '',
          attendanceTime: this.tabParam.educationTime,
          attendeesName: '',
          educationCycle: '',
          editFlag: 'C'
        })
      } else {
        this.popupOptions.title = "교육대상자 검색"; // 교육대상자 검색
        this.popupOptions.param = {
          type: 'multiple',
          targetClassCd: this.targetClassCd,
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/edu/result/educationCompletePop.vue'}`)
        this.popupOptions.visible = true;
        this.popupOptions.width = '70%';
        this.popupOptions.isFull = false;
        this.popupOptions.closeCallback = this.closeTargetUserPopup;
      }
    },
    closeTargetUserPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data.selectData && data.selectData.length > 0) {
        this.$_.forEach(data.selectData, _item => {
          let index = this.$_.findIndex(this.grid.data, {
            attendeesId: _item.userId,
          });
          // 부서 EATC00003
          if (index === -1) {
            this.grid.data.splice(0, 0, {
              eduCourseId: this.tabParam.eduCourseId,
              attendeesNo: uuidv4(),
              attendeesTypeCd: 'EATC00003',
              eduEducationId: this.tabParam.eduEducationId,
              attendeesTypeName: '',
              attendeesPositionName: _item.jobName,
              attendeesDeptName: _item.deptName,
              seniorityName: _item.seniorName,
              attendeesId: _item.userId,
              enterDate: _item.enterDate,
              attendeesName: _item.userName,
              evaluationDate: this.tabParam.educationEndDate,
              attendanceTime: this.tabParam.sumEducationTime,
              editFlag: 'C'
            })
          }
            // 직책 EATC00001
        })
        /* eslint-disable no-unused-vars */ 
        this.$http.url = transactionConfig.sop.edu.plan.insert.targetUser.url;
        this.$http.type = 'POST';
        this.$http.param = this.grid.data;
        this.$http.request((_result) => {
          this.saveCallback1();
        },);
      }
    },  
    openExcelUploader() {
      this.popupOptions.title = '교육대상자 업로드'; // 즉시조치
      this.popupOptions.param = {}
      this.popupOptions.target = () => import(`${'./eduTargetUserExcelUpload.vue'}`);
      this.popupOptions.width = '90%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(_result) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (_result && _result.length > 0) {
        let s_data = this.$_.filter(_result, (item) => { return !item.error_message })
        this.$_.forEach(s_data, _item => {
          let index = this.$_.findIndex(this.grid.data, {
            empNo: _item.empNo,
          });
          // 부서 EATC00003
          if (index === -1) {
            this.grid.data.splice(0, 0, {
              eduCourseId: this.tabParam.eduCourseId,
              attendeesNo: uuidv4(),
              attendeesTypeCd: 'EATC00003',
              eduEducationId: this.tabParam.eduEducationId,
              attendeesTypeName: '',
              attendeesPositionName: '',
              attendeesDeptName: '',
              seniorityName: '',
              empNo: _item.empNo,
              attendeesId: '',
              evaluationDate: this.tabParam.educationEndDate,
              attendanceTime: this.tabParam.sumEducationTime,
              attendeesName: _item.userName,
              editFlag: 'C'
            })
          }
            // 직책 EATC00001
        })
        
        /* eslint-disable no-unused-vars */ 
        this.$http.url = transactionConfig.sop.edu.plan.insert.exceltargetUser.url;
        this.$http.type = 'POST';
        this.$http.param = this.grid.data;
        this.$http.request((_result) => {
          this.saveCallback1();
        },);
      }
    },
    removeItem() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '삭제하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'warning', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.deleteUrl;
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData)
            }
            this.$http.request(() => {
              this.$_.forEach(selectData, item => {
                this.grid.data = this.$_.reject(this.grid.data, { attendeesNo: item.attendeesNo })
              })
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              this.getAttendList();
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    addItem4() {
      this.grid2.data.splice(0, 0, {
        eduCourseId: this.tabParam.eduCourseId,
        attendeesNo: uuidv4(),
        eduEducationId: this.tabParam.eduEducationId,
        attendeesTypeCd: 'EATC00004',
        attendeesPositionCd: '',
        attendeesPositionName: '',
        companyName: '',
        residentNo: '',
        attendanceTime: this.tabParam.educationTime,
        attendeesName: '',
        editFlag: 'C'
      })
    },
    removeItem4() {
      let selectData = this.$refs['table4'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '삭제하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'warning', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.deleteUrl;
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData)
            }
            this.$http.request(() => {
              this.$_.forEach(selectData, item => {
                this.grid2.data = this.$_.reject(this.grid2.data, { attendeesNo: item.attendeesNo })
              })
              this.$refs['table4'].$refs['compo-table'].clearSelection();
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              // this.getAttendList();
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    saveEducation1() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '저장하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$_.forEach(this.grid.data, item => {
            item.regUserId = this.$store.getters.user.userId
            item.chgUserId = this.$store.getters.user.userId
          })
          this.isSave1 = !this.isSave1;
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveEducation2() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '저장하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$_.forEach(this.grid2.data, item => {
            item.regUserId = this.$store.getters.user.userId
            item.chgUserId = this.$store.getters.user.userId
          })
          
          this.isSave2 = !this.isSave2;
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveCallback1() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getAttendList();
    },
    saveCallback2() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getAttendList();
    },
    innerBtnClicked4(col, props) {
      this.grid2.data.splice(props.rowIndex, 0, {
        key: props.row.key, 
        eduCourseId: this.tabParam.eduCourseId,
        attendeesNo: uuidv4(),
        attendeesTypeCd: 'EATC00004',
        eduEducationId: this.tabParam.eduEducationId,
        attendeesPositionCd: '',
        attendeesPositionName: props.row.attendeesPositionName,
        attendeesName: '',
        companyName: props.row.companyName,
        residentNo: props.row.residentNo,
        editFlag: 'C',
      });
    },
    customColor(data, type) {
      if (type === 'EATC00001') {
        return 'primary';
      } else if (type === 'EATC00002') {
        return 'red';
      } else if (type === 'EATC00003') {
        return 'orange';
      } else {
        return 'green';
      }
    },
    selectAdd() {
      this.$refs['table'].selected = [];
      let selectData = this.$refs["gridUser"].selected;
      if (selectData && selectData.length > 0) {
        this.$_.forEach(selectData, _item => {
          let index = this.$_.findIndex(this.grid.data, {
            attendeesId: _item.userId,
          });
          // 부서 EATC00003
          if (index === -1) {
            this.grid.data.splice(0, 0, {
              eduCourseId: this.tabParam.eduCourseId,
              attendeesNo: uuidv4(),
              attendeesTypeCd: 'EATC00003',
              eduEducationId: this.tabParam.eduEducationId,
              attendeesTypeName: '',
              attendeesPositionName: _item.jobName,
              attendeesDeptName: _item.deptName,
              seniorityName: _item.seniorName,
              attendeesId: _item.userId,
              enterDate: _item.enterDate,
              attendeesName: _item.userName,
              evaluationDate: this.tabParam.educationEndDate,
              attendanceTime: this.tabParam.sumEducationTime,
              editFlag: 'C'
            })
          }
        })
        /* eslint-disable no-unused-vars */ 
        this.$http.url = transactionConfig.sop.edu.plan.insert.targetUser.url;
        this.$http.type = 'POST';
        this.$http.param = this.grid.data;
        this.$http.request((_result) => {
          this.saveCallback1();
          this.$refs['gridUser'].selected = [];
        },);
      } else {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '대상자를 선택하세요.',
          type: 'warning', // success / info / warning / error
        });
      }
    },
    openPlan() {
      this.popupOptions.title = '교육대상자 업로드'; // 즉시조치
      this.popupOptions.param = {
        plantCd: this.tabParam.plantCd,
        educationKindCdLarge: this.tabParam.educationKindCdLarge,
        type: 'single'
      }
      this.popupOptions.target = () => import(`${'./educationPlanPop.vue'}`);
      this.popupOptions.width = '90%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePlanPopup;
    },
    closePlanPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.$_.forEach(data, _item => {
          this.$http.url = this.$format(selectConfig.sop.edu.result.get.url, _item.eduEducationId);
          this.$http.type = 'GET';
          this.$http.request((_result) => {
            this.tabParam.eduAttendeeList = _result.data.eduAttendeeList
            this.grid.data = [];
            this.grid2.data = [];
            this.$_.forEach(this.tabParam.eduAttendeeList, _item => {
              if (_item.attendeesTypeCd === 'EATC00004') {
                this.grid2.data.splice(0,0, {
                  eduCourseId: this.tabParam.eduCourseId,
                  attendeesNo: uuidv4(),
                  eduEducationId: this.tabParam.eduEducationId,
                  attendeesTypeCd: 'EATC00004',
                  attendeesPositionCd: _item.attendeesPositionCd,
                  attendeesPositionName: _item.attendeesPositionName,
                  companyName: _item.companyName,
                  residentNo: _item.residentNo,
                  attendanceTime: this.tabParam.educationTime,
                  attendeesName:  _item.attendeesName,
                  editFlag: 'C'
                })
              } else {
                this.grid.data.splice(0, 0, {
                  eduCourseId: this.tabParam.eduCourseId,
                  attendeesNo: uuidv4(),
                  attendeesTypeCd: 'EATC00003',
                  eduEducationId: this.tabParam.eduEducationId,
                  attendeesTypeName: '',
                  attendeesPositionName: _item.attendeesPositionName,
                  attendeesDeptName: _item.attendeesDeptName,
                  seniorityName: _item.seniorityName,
                  attendeesId: _item.attendeesId,
                  enterDate: _item.enterDate,
                  attendeesName: _item.attendeesName,
                  evaluationDate: this.tabParam.educationEndDate,
                  attendanceTime: this.tabParam.sumEducationTime,
                  editFlag: 'C'
                })
              }
            })

            this.$http.url = transactionConfig.sop.edu.plan.insert.targetUser.url;
            this.$http.type = 'POST';
            this.$http.param = this.grid.data;
            this.$http.request((_result) => {
              this.saveCallback1();
              this.$refs['gridUser'].selected = [];
            },);
          },);
        })
      }
    },
    sendMail() {
      /**
       * 대상자들에게 메일 전송
       * 
       * 권한이 있는자에게 줄 것인가?
       * 
       * 교육이 완료되기 전이라면 교육자를 계속 추가할 수 있음으로 버튼을 통해서만 대상자에게 메일을 발송?
       * 그게 아니라고 한다면 배치를 통해서 도래하기전에 메일을 보내는 방법이 존재함
       * 
       * 부서별 담당자는 여러개의 부서를 담당하기도 하는지? : 받은 자료에서는 해당 사항은 적용되지 않긴함
       * 
       * 담당자가 없는 부서 인원이 존재 : 담당자를 넣던지 아니면 로직이 변경되어야 함
       */
      this.$http.url = this.sendMailUrl;
      this.$http.type = 'POST';
      this.$http.param = {
        eduEducationId: this.tabParam.eduEducationId
      };
      this.$http.request((_result) => {
        window.getApp.$emit('APP_REQUEST_SUCCESS');
      },);
    }
  }
};
</script>
